<template>
  <div>
    <el-form
      ref="managerForm"
      :model="manager"
      :rules="rules"
      label-position="top"
      label-width="100px"
      class="my_container"
    >
      <el-row :gutter="24">
        <el-col :xs="24" :sm="12">
          <el-form-item prop="fio" label="ФИО менеджера">
            <el-input
              v-model="manager.fio"
              placeholder="Введите ФИО"
              @input="toCapital"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item prop="login" label="Номер телефона менеджера">
            <input
              v-model="manager.login"
              v-mask="'+7 (###) ###-##-##'"
              class="el-input__inner"
              masked="true"
              placeholder="Введите номер телефона"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :xs="24" :sm="12">
          <el-form-item prop="email" label="Email менеджера">
            <el-input v-model="manager.email" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="buttons-block">
      <el-button style="margin: 20px" type="primary" @click="postItem">
        Сохранить
      </el-button>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { capital_letter } from '@/helpers/functions'

const Managers = RepositoryFactory.get('managers')

export default {
  name: 'ManagerForm',
  props: {
    man: {
      type: Object,
      default: () => undefined,
    },
  },
  data() {
    return {
      manager: {
        fio: '',
        login: '',
        email: '',
      },
      rules: {
        fio: [
          {
            required: true,
            message: 'ФИО обязательно для заполнения',
            trigger: 'blur',
          },
        ],
        login: [
          {
            required: true,
            message: 'Телефон обязателен для заполнения',
            trigger: 'blur',
          },
          {
            min: 18,
            message: 'Телефон заполнен не полностью',
            trigger: 'blur',
          },
        ],
        email: [
          {
            type: 'email',
            message: 'Введите корректный email',
            trigger: ['blur', 'change'],
          },
        ],
      },
    }
  },
  watch: {
    man: {
      immediate: true,
      handler(val) {
        if (val && val.profile) {
          const { profile, phone } = val

          this.manager.fio = profile.fio
          this.manager.login = phone
          this.manager.email = profile.email
        }
      },
    },
  },
  methods: {
    toCapital(val) {
      this.manager.fio = capital_letter(val)
    },
    cleanForm() {
      this.manager.fio = ''
      this.manager.login = ''
      this.manager.email = ''
    },
    postItem() {
      this.$refs['managerForm'].validate(valid => {
        if (valid) {
          if (!this.man) {
            Managers.postItem({
              fio: this.manager.fio,
              login: this.manager.login,
              email: this.manager.email,
              user_org_inn: this.userInfo.current.organization.inn,
            })
              .then(res => {
                if (res.status === 200) {
                  this.$message.success('Менеджер создан успешно')
                  this.cleanForm()
                }
              })
              .catch(err => this.errHandler(err))
          } else {
            Managers.updateItem(this.man.id, {
              fio: this.manager.fio,
              login: this.manager.login,
              email: this.manager.email,
            })
              .then(res => {
                if (res.status === 200) {
                  this.$message.success('Менеджер успешно обновлен')
                  this.$emit('close')
                }
              })
              .catch(err => this.errHandler(err))
          }
        }
      })
    },
  },
}
</script>
